// extracted by mini-css-extract-plugin
export default {"Backdrop":"Modal_Backdrop__chl-9","Modal":"Modal_Modal__vN8ud"};